/*jshint esversion: 11 */
/**
 *  Cette classe permet de lancer une géolocalisation dans une zone définie ou pas et renvoie la position ou un message d'erreur.
 *
 * Voici le paramétrage possible :
 *
 *  settings = {
 *    selectorBtn: '',
 *    selectorStatus : '',
 *    labels : {
 *       unauthorized : '',
 *       error : '',
 *       success : '',
 *       inprogress : '',
 *       outside : ''
 *    },
 *    bounds : '', //maplibregl.LngLatBounds
 *    success : (position) => {},
 *    error : (error) => {},
 *    changeStatus : (status) => {}
 *  }
 */

class Geolocation {
  constructor(selectorBtn, settings) {

    this.geolocBtnElement = document.querySelector(selectorBtn);

    this.settings = settings ? settings : {};

    if (this.settings.selectorStatus) {
      this.statusHtmlElement = document.querySelector(settings.selectorStatus);
    }

    this.labels = {
      unauthorizedGeoloc : this.settings.labels && this.settings.labels.unauthorizedGeoloc ? this.settings.labels.unauthorizedGeoloc : 'La géolocalisation n\'a pas été autorisée !',
      errorGeoloc : this.settings.labels && this.settings.labels.errorGeoloc ? this.settings.labels.errorGeoloc : 'Les données de géolocalisation sont indisponibles.',
      successGeoloc : this.settings.labels && this.settings.labels.successGeoloc ? this.settings.labels.successGeoloc : 'Géolocalisation réussie !',
      inprogress : this.settings.labels && this.settings.labels.inprogress ? this.settings.labels.inprogress : 'Géolocalisation en cours...',
      outsideBounds : this.settings.labels && this.settings.labels.outsideBounds ? this.settings.labels.outsideBounds : 'Vous vous situez en dehors de la Métropole de Lyon.',
      notcompatible : this.settings.labels && this.settings.labels.notcompatible ? this.settings.labels.notcompatible : 'Votre navigateur ne supporte pas la géolocalisation !'
    };

    if (this.settings.bounds) {
      this.bounds = this.settings.bounds;
    }

    this._init();
  }

  _init() {
    const self = this;
    this.geolocBtnElement.addEventListener('click', (e) => {
      e.preventDefault();

      self._changeStatus(this.labels.inprogress);

      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            self._success(position);
          },
          (error) => {
            console.log(error.message,"geolocation error");
            self._error(this.labels.errorGeoloc);
          }
        );
      }
      else {
        self._changeStatus(this.labels.notcompatible);
      }
    });
  }

  _success(position) {
    let hasPosition = false;

    if (this.bounds) {
      if (this._inBounds(position)) {
        hasPosition = true;
      } else {
        this._error(this.labels.outsideBounds);
      }
    } else {  //pas de limite de zone
      hasPosition = true;
    }

    if (hasPosition) {
      this._changeStatus(this.labels.successGeoloc);

      if (this.settings.success) {
        this.settings.success.call(this, position.coords);
      }
    }
  }

  _error(error) {
    this._changeStatus(error);

    if (this.settings.error) {
      this.settings.error.call(this, error);
    }
  }

  _changeStatus(status) {
    if (this.statusHtmlElement) {
      this.statusHtmlElement.textContent = status;
    }

    if (this.settings.changeStatus) {
      this.settings.changeStatus.call(this, status);
    }
  }

  clearStatus() {
    if (this.statusHtmlElement) {
      this.statusHtmlElement.textContent = '';
    }
  }

  _inBounds(point) {
    //console.log(point, this.bounds, "inbounds");
    if(point) {
      //console.log((point.coords.longitude - this.bounds._ne.lng) * (point.coords.longitude - this.bounds._sw.lng), "calcul lng");
      //console.log((point.coords.latitude - this.bounds._ne.lat) * (point.coords.latitude - this.bounds._sw.lat), "calcul lat")
      var lng = (point.coords.longitude - this.bounds._ne.lng) * (point.coords.longitude - this.bounds._sw.lng) < 0;
      var lat = (point.coords.latitude - this.bounds._ne.lat) * (point.coords.latitude - this.bounds._sw.lat) < 0;

      return lng && lat;
    }

    return false;
  }
}
